module.exports = __webpack_public_path__ + "img/12.6e058b97.jpg";